import { render, staticRenderFns } from "./TabPasswordPolicy.vue?vue&type=template&id=2ad02e00&scoped=true&"
import script from "./TabPasswordPolicy.vue?vue&type=script&lang=js&"
export * from "./TabPasswordPolicy.vue?vue&type=script&lang=js&"
import style0 from "./TabPasswordPolicy.vue?vue&type=style&index=0&id=2ad02e00&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ad02e00",
  null
  
)

export default component.exports